module.exports = __webpack_public_path__ + "static/item-3-d747f473c8049eeb5b6a14d0c7e5a523.png";